<template>
  <div class="indexPageBox">
    <div class="bannerBox1">
      <HeaderCom></HeaderCom>
      <div style="height: 520px">
        <div class="banner_item" style="background-image: url('static/image/fp_bg.png');">
          <div class="banner_item1_content">
            <p>防火指挥调度系统</p>
            <p class="txt1">
              创新监管方式，加强事中事后监管，规范执法行为 实现互联网+
              监督执法模式的转变，
            </p>
            <div class="item1_infoBox">
              立即申请
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box">
      <div class="part1_content">
        <div class="part1_header">
          <span>方案背景</span>
          <span>全面推开将为科学高效监管提供新思路</span>
        </div>
        <div class="part1_section">
          <img src="static/image/fp_part1_bg.png" alt="">
        </div>
      </div>
    </div>
    <div class="part2Box">
      <div class="part2_content">
        <div class="part2_header">
          <span class="part2_header_txt1">方案简介</span>
          <span class="part2_header_txt2">全面推开将为科学高效监管提供新思路</span>
          <span class="part2_header_txt3">防火指挥调度系统针对城市火灾防控信息离散，存在的火灾隐患很难及时治理，长期容易引发城市火灾威胁人民生命财产的问题，以大数据、云计算、移动互联等技术与传统成熟信息技术相结合为关键支撑，通过火灾防控信息的汇聚，火灾隐患的分级分类、调度处理以及为专项行动治理等功能实现城市火灾隐患的综合治理，形成完善的防火指挥调度管理体系，提高城市火灾预防执行效能。</span>
        </div>
        <div class="part2_bg1">
          <img src="static/image/fp_part1_bg1.png" alt="">
        </div>
        <div>
          <img src="static/image/fp_part1_bg2.png" alt="">
        </div>
      </div>
    </div>
    <div class="part3Box">
      <div class="part3_content">
        <div class="part2_header">
          <span class="part2_header_txt1">解决方案</span>
          <span class="part2_header_txt2">全面推开将为科学高效监管提供新思路</span>
        </div>
        <div>
          <img src="static/image/fp_part4_bg.png" alt="">
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part4_content_item">
          <div>
            <img src="static/image/fp_part4_bg1.png" alt="">
          </div>
          <div>
            防火信息采集
          </div>
          <div>
            重点单位/微型消防站管理、九小场所/移动请勿、群众举报、消防维保/检测评估、消防物联/远程
          </div>
        </div>
        <div class="part4_content_item">
          <div>
            <img src="static/image/fp_part4_bg1.png" alt="">
          </div>
          <div>
            隐患分类筛选
          </div>
          <div>
            隐患台账、分类分级、数量统计、区域统计、灰名单、黑名单
          </div>
        </div>
        <div class="part4_content_item">
          <div>
            <img src="static/image/fp_part4_bg1.png" alt="">
          </div>
          <div>
            调度处理处置
          </div>
          <div>
            有明确主体责任、无明确主体责任、人工核实主体责任、专业服务机构、应急模式
          </div>
        </div>
        <div class="part4_content_item">
          <div>
            <img src="static/image/fp_part4_bg1.png" alt="">
          </div>
          <div>
            专项指挥决策
          </div>
          <div>
            决策依据、专项计划、行动命令、执行反馈、效果评估
          </div>
        </div>
      </div>
    </div>
    <div class="part5Box">
      <div class="part5_content">
        <div class="part5_content_btn">
          主要功能框架
        </div>
        <div class="part5_content_item">
          <div>

          </div>
        </div>
        <div class="part5_content_item1">
          <div></div>
          <div class="part5_content_border"></div>
          <div></div>
          <div class="part5_content_border"></div>
          <div></div>
        </div>
        <div class="part5_content_item2">
          <div :class="item.bgColor" v-for="(item,index) in resultList" :key="index+'resultList'" @mouseover="addActive($event,index)" @mouseleave="removeActive($event,index)">
            <div>
              <img :src="item.normalSrc" alt="">
            </div>
            <span :class="item.txt1Class">{{item.txt1}}</span>
            <span :class="item.txt2Class" v-for="(item1,index1) in item.txt2" :key="index1">{{item1}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <div class="part6_header">
          <span>系统优势</span>
          <span>全面推开将为科学高效监管提供新思路</span>
        </div>
        <div class="part6_content_item">
          <div class="part6_item_box" v-for="(item,index) in part6List" :k="index+'part6List'">
            <div class="part6_info1">
              <img :src="item.normalSrc" alt="">
            </div>
            <div class="part6_info2">
              <p>{{item.txt1}}</p>
              <p>{{item.txt2}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RegisterCom></RegisterCom>
    <FooterCom></FooterCom>
  </div>
</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
  import RegisterCom from "../common/registerCom"
  export default {
    name: "firePrevention",
    components: {HeaderCom, FooterCom,RegisterCom},
    data(){
      return{
        isActive:1,
        resultList:[
          {
            normalSrc:"static/image/fp_part5_bg1.png",
            txt1:"数据中心",
            txt2:["消管通子系统","其他子系统","数据抽取、缓存","数据清洗、转换","加载到数据中心"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/fp_part5_bg2.png",
            txt1:"防火信息",
            txt2:["社会单位","九小场所","老旧小区/城中村","火灾高危区域","人员密集场所"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/fp_part5_bg3.png",
            txt1:"隐患情报",
            txt2:["火灾隐患分类","火灾隐患分级","火灾隐患名单","火灾隐患黑名单"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/fp_part5_bg4.png",
            txt1:"防火调度",
            txt2:["自动调度","人工调度","专项行动","跨系度调度"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/fp_part5_bg5.png",
            txt1:"专项行动指挥",
            txt2:["专项行动计划","专项行动命令","双向视频指挥","跨系度指挥","结果反馈"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/fp_part5_bg6.png",
            txt1:"综合管理",
            txt2:["一张图监控","一张图指挥","系统设置","对接参数设置","其他系统对接"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
        ],
        part6List:[
          {
            normalSrc:"static/image/fp_part6_bg1.png",
            txt1:"打造全网智慧消防通道",
            txt2:"国内首家具备智慧消防全套解决方案的厂家",
          },
          {
            normalSrc:"static/image/fp_part6_bg2.png",
            txt1:"大数据管控",
            txt2:"大数据、一张图，实现各个系统火灾防控信息的大数据汇聚，隐患分析‘防火调度和专项行动指挥，形成完善的火灾隐患闭环体系，实现城市火灾防控的大数据管控",
          },{
            normalSrc:"static/image/fp_part6_bg3.png",
            txt1:"双向调度指挥",
            txt2:"可以与各火灾防控系统对接实现反向调度指挥，形成双向闭环的业务链系统",
          },{
            normalSrc:"static/image/fp_part6_bg4.png",
            txt1:"AI智能语音识别",
            txt2:"人工智能语音识别进行查询和指挥调度",
          },{
            normalSrc:"static/image/fp_part6_bg5.png",
            txt1:"用户体验极佳",
            txt2:"多年与消防总队、支队、大队业务交流及探索，站在客户角度进行产品规划及系统设计",
          },{
            normalSrc:"static/image/fp_part6_bg6.png",
            txt1:"行业专业素养",
            txt2:"三十年消防行业积累沉淀，深入了解监管部门、使用部门具体业务需求，落地能力强",
          },
        ]

      }
    },
    methods: {
      handleClick(index) {
        this.isActive = index;
      },
      addActive(e,index){
        this.resultList[index].normalSrc = "static/image/fp_part5_bg"+(index+1)+"Active.png";
        this.resultList[index].bgColor = "part5_item2_info part5_item2_infoActive";
        this.resultList[index].txt1Class = "part5_item2_txt1 part5_item2_txt1Active";
        this.resultList[index].txt2Class = "part5_item2_txt2 part5_item2_txt2Active";
      },
      removeActive(e,index){
        this.resultList[index].normalSrc = "static/image/fp_part5_bg"+(index+1)+".png";
        this.resultList[index].bgColor = "part5_item2_info";
        this.resultList[index].txt1Class = "part5_item2_txt1";
        this.resultList[index].txt2Class = "part5_item2_txt2";
      },
    }
  }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  .part1Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  .part1_content{
    width: 1200px;
    box-sizing: border-box;
    padding: 60px 0;
  }
  .part1_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part1_header>span:nth-of-type(1){
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 30px 0 60px 0;
  }
  .part1_section{
    width: 100%;
    box-sizing: border-box;
    display: flex;
  }
  .part2Box{
    width:100%;
    height:1100px;
    background:rgba(238,242,254,1);
    display: flex;
    justify-content: center;
  }
  .part2_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .part2_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 65px 0 0 0;
    flex-direction: column;
    align-items: center;
  }
  .part2_bg1{
    box-sizing: border-box;
    padding:10px 0 35px 0;
  }
  .part2_header_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part2_header_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 20px 0 55px 0;
  }
  .part2_header_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
  }
  .part3Box{
    width: 100%;
    display: flex;
    justify-content: center;
    background: #ffffff;
  }
  .part3_content{
    width: 1200px;
    box-sizing: border-box;
    padding:0 0 60px 0;
  }
  .part4Box{
    width: 100%;
    display: flex;
    justify-content: center;
    background:rgba(238,242,254,1);
  }
  .part4_content{
    width: 1200px;
    height: 400px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 90px 0 0 0;
  }
  .part4_content_item{
    width: 220px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .part4_content_item>div:nth-of-type(1)>img{
    display: inline-block;
    width: 100px;
    height: 100px;
  }
  .part4_content_item>div:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:26px;
    box-sizing: border-box;
    padding:0 0 25px 0;
  }
  .part4_content_item>div:nth-of-type(3){
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:26px;
  }
  .part5Box{
    width: 100%;
    height: 650px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background:#ffffff;
  }
  .part5_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part5_content_btn{
    width:280px;
    height:60px;
    background:rgba(42,98,255,1);
    border-radius:5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .part5_content_item{
    width: 1000px;
    height: 58px;
    border-bottom:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item>div{
    width: 50%;
    height: 100%;
    border-right:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item1{
    width: 1000px;
    height: 48px;
    box-sizing: border-box;
    display: flex;
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
  }
  .part5_content_item1>div{
    flex: 1;
  }
  .part5_content_item2{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .part5_item2_info{
    width:180px;
    height:300px;
    background:rgba(240,240,240,1);
    border-radius:5px;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: 30px 0 0 0;
    cursor: pointer;
  }
  .part5_item2_infoActive{
    background: #2A62FF;
  }
  .part5_item2_txt1{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(42,98,255,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part5_item2_txt1Active{
    color: #FFFF00;
  }
  .part5_item2_txt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:30px;
  }
  .part5_item2_txt2Active{
    color: #FFFFFF;
  }
  .part5_content_border{
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
  }
  .part5_box2_txtInfo>div{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .part5_box2_txtInfo>div>span{
    font-size:12px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(195,206,234,1);
    line-height:22px;
  }
  .part6Box{
    width: 100%;
    height: 700px;
    background:rgba(7,30,94,1);
    display: flex;
    justify-content: center;
  }
  .part6_content{
    width: 1200px;
    height: 100%;
  }
  .part6_header{
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .part6_header>span:nth-of-type(1){
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(255,255,255,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 78px 0 0 0;
  }
  .part6_header>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:30px;
    padding: 20px 0 55px 0;
  }
  .part6_content_item{
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .part6_item_box{
    width:380px;
    height:180px;
    background:rgba(255,255,255,1);
    box-sizing: border-box;
    padding: 18px 58px 0 58px;
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 30px 0;
  }
  .part6_info1{
    width: 50px;
    box-sizing: border-box;
    padding: 5px 5px 0 0;
  }
  .part6_info1 img{
    display: inline-block;
  }
  .part6_info2{
    flex: 1;
  }
  .part6_info2>p:nth-of-type(1){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:30px;
  }
  .part6_info2>p:nth-of-type(2){
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(153,153,153,1);
    line-height:22px;
    box-sizing: border-box;
    padding: 10px 0 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/info/firePrevention.vue